module.exports = __webpack_public_path__ + "static/media/logo.87e6dd87.png";